module.exports = __webpack_public_path__ + "static/media/6530.8a6d3dd4.jpg";